import React from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Colis } from "@/interfaces/Return";
import { toast } from "@/hooks/use-toast";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { ScanBarcode } from "lucide-react";
import ScanPackage from "./ScannedColis";

interface ColisScannerProps {
  scannedColis: Colis[];
  setScannedColis: React.Dispatch<React.SetStateAction<Colis[]>>;
  colis: Colis[];
}

const ColisScanner: React.FC<ColisScannerProps> = ({
  colis,
  setScannedColis,
  scannedColis,
}) => {
  const [colisCode, setColisCode] = React.useState("");

  const handleAddColis = () => {
    if (colisCode) {
      const colisExists = colis?.some((colis) => colis.colisCode === colisCode);
      if (!colisExists) {
        toast({
          title: "Code colis invalide",
          description: "Ce colis n'existe pas dans la demande",
          variant: "destructive",
        });
        setColisCode("");
        return;
      }
      if (scannedColis.some((colis) => colis.colisCode === colisCode)) {
        toast({
          title: "Colis déjà scanné",
          variant: "destructive",
        });
        setColisCode("");
        return;
      }

      const newColis = colis.find((c) => c.colisCode === colisCode);
      if (newColis) setScannedColis([...scannedColis, newColis]);
      setColisCode("");
      toast({
        title: "Colis ajouté avec succès",
        variant: "success",
      });
    }
  };

  const handleColisCodeChange = (value: string) => {
    setColisCode(value.trim());
  };
  return (
    <>
      <div className="px-4 flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          <div className="text-sm text-muted-foreground">
            Progrès: {scannedColis.length} / {colis?.length || 0} colis scannés
          </div>
          <div className="flex items-center justify-between gap-2">
            <Input
              placeholder="Scanner un colis"
              className="w-full h-10"
              value={colisCode}
              onChange={(e) => handleColisCodeChange(e.target.value)}
              disabled={false}
              onKeyDown={(e) => {
                e.key === "Enter" && handleAddColis();
              }}
            />
            <Button
              variant="outline"
              className="h-10"
              disabled={false}
              onClick={() => handleAddColis()}
            >
              <ScanBarcode className="h-6 w-6" />
            </Button>
          </div>
        </div>
      </div>
      <div className="px-4 flex flex-grow flex-col gap-4">
        <ScrollArea className="flex-1 max-h-[325px]" showScrollIndicator>
          {scannedColis &&
            scannedColis.map((colis, index) => (
              <ScanPackage
                key={index}
                colis={colis}
                isScanned={scannedColis.some(
                  (scannedColis) => scannedColis.colisCode === colis.colisCode
                )}
              />
            ))}
        </ScrollArea>
      </div>
    </>
  );
};

export default ColisScanner;
